import { env } from "@/env";

export const IS_DEVELOPMENT = process.env.NODE_ENV === "development" || env.DEV;

export const COLOR_SCHEMES = ["light", "dark"] as const;

export const VERIFICATION_CODE_LENGTH = 6;
export const VERIFICATION_CODE_RESEND_TIMEOUT_IN_SECONDS = env.DEV ? 5 : 60;

export const MATCH_PREFERS_COLOR_SCHEME_DARK = "(prefers-color-scheme: dark)";

export const PAGE_PRIVACY_POLICY_URL = "https://imperfect.so/legal/privacy";
export const PAGE_AI_USAGE_URL = "https://imperfect.so/legal/ai-usage";
export const PAGE_TERMS_AND_CONDITIONS_URL = "https://imperfect.so/legal/terms";

export const REFLECTION_TARGET = 10;
export const FRIEND_CHECK_TARGET = 3;
export const CHOSEN_CORE_VALUES_LIMIT = 5;

export const PERFECT_DAY_SUMMARY_MAX_CHARACTERS_LENGTH = 250;
export const PERFECT_DAY_NEW_SCENE_MESSAGE_DELAY_IN_MILLISECONDS = 1500;

export const REQUIRED_CORE_VALUE_ACCURACY_TO_CHOOSE_CORE_VALUES = 50;
